import { Component } from '@angular/core';
import { HealthcareCardContainer } from '../healthcare-card-container/healthcare-card-container';
import { CardInfoService } from '../../../../shared/services/card-info.service';
import { CARD_INFO_ENUM, ICardInfoData } from '../../../../shared/interfaces/card-info.interface';

@Component({
  selector: 'app-healthcare-choose-us',
  imports: [HealthcareCardContainer],
  templateUrl: './healthcare-choose-us.html',
  styleUrl: './healthcare-choose-us.scss'
})
export class HealthcareChooseUs {

  public cardInfo: ICardInfoData[] = []

  constructor(private cardInfoService: CardInfoService) {
  }

  ngOnInit() {
    this.cardInfo = this.cardInfoService.getCardInfoData(CARD_INFO_ENUM.HEALTHCARE_MARKETING);
  }

}
